"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingRuleFactory = exports.TPricingRuleName = void 0;
const PricingRuleComplementaryByCategory_1 = require("./PricingRuleComplementaryByCategory");
const PricingRuleComplementaryByItem_1 = require("./PricingRuleComplementaryByItem");
/**
 * Pricing Rules are the rules that tell how the overall price of a built
 * product should be affected when the quantity of certain item or the
 * quantity of items in certain category is changed.
 */
var TPricingRuleName;
(function (TPricingRuleName) {
    TPricingRuleName["complementaryByCategory"] = "complementaryByCategory";
    TPricingRuleName["complementaryByItem"] = "complementaryByItem";
})(TPricingRuleName = exports.TPricingRuleName || (exports.TPricingRuleName = {}));
/**
 * Given an arbitrary serialized pricing rule, returns its unserialized form.
 */
const pricingRuleFactory = (pricingRule) => {
    switch (pricingRule.name) {
        case TPricingRuleName.complementaryByCategory: {
            return PricingRuleComplementaryByCategory_1.PricingRuleComplementaryByCategory.unserialize(pricingRule);
        }
        case TPricingRuleName.complementaryByItem: {
            return PricingRuleComplementaryByItem_1.PricingRuleComplementaryByItem.unserialize(pricingRule);
        }
        default:
            // just in case services has got ahead and is using a restriction rule
            // the client doesn't understand we just exclude it
            console.error(`unrecognized pricing rule name: ${pricingRule.name}`);
            return null;
    }
};
exports.pricingRuleFactory = pricingRuleFactory;
//# sourceMappingURL=index.js.map